﻿<template>
  <section>
    <div class="row collapse">
      <h3 class="small-11 columns header-with-icon">
        <span
          :class="'icon-large policy-type-name-' + quickQuote.Type.replace('_', '')"
          data-test="quickquote-conv-title-icon"
        />
        <span data-test="quickquote-conv-title-text" v-text="quickQuote.Name" />
      </h3>
      <h3 class="small-1 columns header-with-icon">
        <ul v-if="quickQuote.StateEnum === 2" class="list-circle-check-icon--medium">
          <li />
        </ul>
        <ul v-else-if="quickQuote.StateEnum === 3" class="list-icon-error--medium">
          <li />
        </ul>
        <div v-else>
          <div class="spinner spinner-button" />
        </div>
      </h3>
    </div>
  </section>
</template>

<script lang="ts">
import { QuickQuoteStatus, initiateConversion } from './types/QuickQuoteStatus';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'ConversionItem',
  props: {
    data: {
      type: Object as PropType<QuickQuoteStatus>,
      required: true
    }
  },
  data() {
    return {
      quickQuote: this.data
    };
  },
  mounted() {
    initiateConversion(this.quickQuote)
      .catch(() => {
        this.$emit('conversionError', this.quickQuote.PolicyCacheId);
      })
      .finally(() => {
        this.$emit('conversionDone', this.quickQuote.PolicyCacheId);
      });
  }
});
</script>
